import React from 'react';
import clsx from 'clsx';
import styles from './AttachmentPills.module.scss';
import { crossIconBlack } from '../../../assets/hostedassets';
import { truncateByCharacters } from '../../../utils/utils';
import { ATTACHMENT_PILL_LABEL_MAX_CHARS } from '../constants';
import type { SystemAttachmentKey } from '../constants';
import type { AttachmentPill } from '../types';

interface AttachmentPillsProps {
    pills: AttachmentPill[];
    onPillClick: (pill: AttachmentPill) => void;
    onRemoveManual: (docId: number) => void;
    onRemoveSystem: (key: SystemAttachmentKey) => void;
}

const AttachmentPills: React.FC<AttachmentPillsProps> = ({ pills, onPillClick, onRemoveManual, onRemoveSystem }) => {
    if (!pills.length) return null;

    return (
        <div className={styles.AttachmentPills}>
            {pills.map((pill) => (
                <div key={pill.id} className={clsx(styles.Pill, { [styles.ManualPill]: pill.isManual })}>
                    <button type="button" className={styles.PillLabel} onClick={() => onPillClick(pill)} title={pill.label}>
                        {truncateByCharacters(pill.label, ATTACHMENT_PILL_LABEL_MAX_CHARS)}
                    </button>
                    <button
                        type="button"
                        className={styles.RemoveButton}
                        aria-label={`Remove ${pill.label}`}
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            if (pill.isManual && pill.docId !== undefined) {
                                onRemoveManual(pill.docId);
                            } else if (pill.systemKey) {
                                onRemoveSystem(pill.systemKey);
                            }
                        }}
                    >
                        <img src={crossIconBlack} alt="" aria-hidden="true" />
                    </button>
                </div>
            ))}
        </div>
    );
};

export default AttachmentPills;
